import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { LeadershipTeaser } from "@/components/site/LeadershipTeaser";
import { WhatWeBuild } from "@/components/site/WhatWeBuild";
import { WhereWeFocus } from "@/components/site/WhereWeFocus";
import { WhyDNHDD } from "@/components/site/WhyDNHDD";
import { FortimWay } from "@/components/site/FortimWay";
import { Vision } from "@/components/site/Vision";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { LeadershipPage } from "@/components/site/LeadershipPage";
import { scrollToId } from "@/components/site/shared";

function Home() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    const lenis = window.__lenis;

    // Reset any scroll carried over from the previous route immediately.
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);

    if (!target) return;

    // Lenis caches the document height; after an SPA route change it is stale
    // and clamps scrollTo to the old (short) height. Resize it, then scroll.
    // Retry once more after layout/images settle so the target is accurate.
    const jump = () => {
      if (window.__lenis) {
        window.__lenis.resize();
        scrollToId(target);
      } else {
        const el = document.getElementById(target);
        if (el) window.scrollTo({ top: el.offsetTop - 80, behavior: "smooth" });
      }
    };

    const t1 = setTimeout(jump, 220);
    const t2 = setTimeout(jump, 600);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [location]);

  return (
    <main>
      <Hero />
      <About />
      <LeadershipTeaser />
      <WhatWeBuild />
      <WhereWeFocus />
      <WhyDNHDD />
      <FortimWay />
      <Vision />
      <Contact />
    </main>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="App grain" style={{ backgroundColor: "#FAF9F7" }}>
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leadership" element={<LeadershipPage />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
